// src/App.tsx

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthGuard } from './components/AuthGuard';
import { AdminGuard } from './components/AdminGuard';
import { AppLayout } from './components/AppLayout';
import { AdminLayout } from './components/AdminLayout';
import { LoginPage } from './pages/LoginPage';
import { YearsPage } from './pages/YearsPage';
import { EventsPage } from './pages/EventsPage';
import { PhotosPage } from './pages/PhotosPage';
import { PhotoViewer } from './pages/PhotoViewer';
import { SearchPage } from './pages/SearchPage';
import { UserListPage } from './pages/admin/UserListPage';
import { CreateUserPage } from './pages/admin/CreateUserPage';
import { EditPermissionsPage } from './pages/admin/EditPermissionsPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        {/* Protected routes wrapped in AuthGuard + AppLayout */}
        <Route element={<AuthGuard />}>
          <Route element={<AppLayout />}>
            <Route path="/years" element={<YearsPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/years/:year" element={<EventsPage />} />
            <Route path="/years/:year/:event" element={<PhotosPage />} />
            <Route path="/years/:year/:event/:photoIndex" element={<PhotoViewer />} />
          </Route>
        </Route>

        {/* Admin routes wrapped in AuthGuard + AdminGuard + AdminLayout */}
        <Route element={<AuthGuard />}>
          <Route element={<AdminGuard />}>
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<UserListPage />} />
              <Route path="create" element={<CreateUserPage />} />
              <Route path="users/:userId/permissions" element={<EditPermissionsPage />} />
            </Route>
          </Route>
        </Route>

        {/* Default redirect */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
